import React, { FC } from 'react'

import { PublicNode } from '../../../__generated__/api'

import { SearchTreeItem } from './types'
import { autocompleteItemIconProvider, searchTreeItemIconProvider } from './utils'

type Props = {
  item?: SearchTreeItem<PublicNode>
  src?: string
}

export const PublicNodeIcon: FC<Props> = ({ item, src }) => {
  const icon = item ? searchTreeItemIconProvider(item) : autocompleteItemIconProvider(src)
  return (
    <img
      src={icon}
      aria-hidden="true"
      style={{
        width: '28px',
        height: '28px',
        filter:
          'brightness(0) saturate(100%) invert(28%) sepia(73%) saturate(631%) hue-rotate(114deg) brightness(93%) contrast(107%)',
        shapeRendering: 'crispEdges',
      }}
    />
  )
}
